document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('selector-cantidad');
  const btnUnidad = document.getElementById('variant-unity');
  const btnCaja = document.getElementById('variant-box');
  const addToCartBtn = document.getElementById('normalAddToCartBtn');
  const addAndGoCheckout = document.getElementById('addAndGoCheckout');
  const quantityInput = document.getElementById('product-quantity-input');
  const variantsContent = document.getElementById('variants-content');

  const unitsPerBox = Number(btnCaja?.dataset.unitsPerBox) || 0;

  function setMode(mode) {
    const isBoxSelected = mode === 'caja';
    btnUnidad.classList.toggle('active', !isBoxSelected);
    btnCaja.classList.toggle('active', isBoxSelected);

    addToCartBtn?.setAttribute('data-is-box', isBoxSelected);
    addAndGoCheckout?.setAttribute('data-is-box', isBoxSelected);

    addToCartBtn?.setAttribute('data-product-quantity', '1');
    addAndGoCheckout?.setAttribute('data-product-quantity', '1');
    if (quantityInput) quantityInput.value = '1';
  }

  function getActiveVariantQty() {
    const el = document.querySelector('#variants-content input.active');
    if (!el) return null;
    const qty = Number(el.dataset.variantQuantity);
    return Number.isFinite(qty) ? qty : null;
  }

  function getActiveVariantName() {
    const el = document.querySelector('#variants-content input.active');
    if (!el) return null;
    return el.value;
  }

  function disableCaja() {
    btnCaja.disabled = true;
    btnCaja.setAttribute('aria-disabled', 'true');
    btnCaja.classList.add('disabled');
    if (btnCaja.classList.contains('active')) setMode('unidad');
  }

  function enableCaja() {
    btnCaja.disabled = false;
    btnCaja.removeAttribute('aria-disabled');
    btnCaja.classList.remove('disabled');
  }

  function updateCajaState() {
    const variantQty = getActiveVariantQty();
    if (variantQty == null || unitsPerBox <= 0) {
      enableCaja();
      return;
    }
    if (variantQty < unitsPerBox) {
      disableCaja();
    } else {
      enableCaja();
    }
  }

  // Clicks en los botones de formato
  toggle.addEventListener('click', function (e) {
    const target = e.target.closest('button');
    if (!target) return;
    if (target === btnCaja && btnCaja.disabled) return;
    const mode = target.dataset.value === 'caja' ? 'caja' : 'unidad';
    // limpiar activas previas y setear modo
    [...toggle.querySelectorAll('button')].forEach(b => b.classList.remove('active'));
    setMode(mode);
  });

  btnCaja.addEventListener('click', function (e) {
    let variantName = getActiveVariantName() + "-CAJA"

    let newProductImgs = document.querySelectorAll(".product-image-variant");
    let newSliderImgs = document.querySelectorAll(".slider-image-variant");
    let addedActive = false;
    newProductImgs.forEach((img, i) => {
      img.classList.add("d-none");
      img.classList.remove("active-variant");
      img.classList.remove("active");
      newSliderImgs[i].classList.add("d-none");
      newSliderImgs[i].classList.remove("active-variant");
      newSliderImgs[i].classList.remove("active");

      let alt = img.querySelector("img").alt;
      if (alt === variantName) {
        img.classList.remove("d-none");
        img.classList.add("active-variant");
        newSliderImgs[i].classList.remove("d-none");
        newSliderImgs[i].classList.add("active-variant");
        if (!addedActive) {
          newSliderImgs[i].classList.add("active");
          addedActive = true;
        }
      }
    })
  })

  btnUnidad.addEventListener('click', function (e) {
    let variantName = getActiveVariantName()

    let newProductImgs = document.querySelectorAll(".product-image-variant");
    let newSliderImgs = document.querySelectorAll(".slider-image-variant");
    let addedActive = false;
    newProductImgs.forEach((img, i) => {
      img.classList.add("d-none");
      img.classList.remove("active-variant");
      img.classList.remove("active");
      newSliderImgs[i].classList.add("d-none");
      newSliderImgs[i].classList.remove("active-variant");
      newSliderImgs[i].classList.remove("active");

      let alt = img.querySelector("img").alt;
      if (alt === variantName) {
        img.classList.remove("d-none");
        img.classList.add("active-variant");
        newSliderImgs[i].classList.remove("d-none");
        newSliderImgs[i].classList.add("active-variant");
        if (!addedActive) {
          newSliderImgs[i].classList.add("active");
          addedActive = true;
        }
      }
    })
  })

  // Reaccionar a cambios de variante
  if (variantsContent) {
    variantsContent.addEventListener('click', updateCajaState, true);
    variantsContent.addEventListener('change', updateCajaState, true);
    const mo = new MutationObserver(updateCajaState);
    mo.observe(variantsContent, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  // Inicial
  setMode('unidad');
  updateCajaState();
  
});